import React from "react";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import { ThemeVariant } from "../../../utils/constants/generic-types";
import { Image, Stack } from "react-bootstrap";
import "./SaveHyperOnIos.scss";
import IosShareIcon from "../../icons/IosShareIcon";
import ImageAddToHomeScreen from "../../../images/add-to-home-screen.png";
import { SaveHyperModalProps } from "../types";

export default function SaveHyperOnIos({
  isOpen,
  onClose,
  theme = ThemeVariant.LIGHT,
}: SaveHyperModalProps) {
  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      containerClass={`SaveHyperOnIosModal ${
        theme === ThemeVariant.DARK ? "Dark" : ""
      }`}
    >
      <Stack gap={4} className="pt-3 SaveHyperOnIosContent">
        <Stack gap={2} className="text-center Copy">
          <h2 className="fs-6 Hanson-700 SpecialFontSettings Heading">
            Add Hyper Web to Home Screen to turn on notifications.
          </h2>
          <p className="Grotesk SpecialFontSettings SubText">App size: 1 MB</p>
        </Stack>

        <ul className="d-flex flex-column gap-4 mt-2 mb-0 Instructions">
          <li className="d-flex Instruction">
            <p className="Hanson-700 InstructionCount">1</p>
            <p className="d-inline-flex align-items-center Grotesk InstructionText">
              Tap "
              <span className="d-inline-flex align-items-center justify-content-center ShareIcon">
                <IosShareIcon />
              </span>
              " on your iPhone.
            </p>
          </li>
          <li className="d-flex Instruction">
            <p className="Hanson-700 InstructionCount">2</p>
            <p className="Grotesk InstructionText">
              Find "Add to Home Screen" on the pop up
            </p>
          </li>
          <li className="d-flex Instruction">
            <p className="Hanson-700 InstructionCount">3</p>
            <p className="Grotesk InstructionText">
              Tap "Add to Home Screen" to save Hyper as an app.
            </p>
          </li>
        </ul>

        <Image
          src={ImageAddToHomeScreen}
          width={300}
          height={200}
          alt="iOS Add to Home Screen explainer image"
        />
      </Stack>
    </BottomDrawer>
  );
}
